import { Container, Header } from 'components/credits/credit-details/ArticulationCreditItemDetails/components';

import { Articulation } from 'types/articulation';
import { ArticulationDetailsCard } from 'components/credits/credit-details/ArticulationDetailsCard';
import { CreditItemDetailsButtonContainer } from 'components/credits/credit-details/CreditItemDetailsButtonContainer';
import CreditItemDetailsFooter from 'components/credits/credit-details/CreditItemDetailsFooter';
import { CreditType } from 'types/credit';
import FlexContainer from 'components/common/FlexContainer';
import { Spin } from 'antd';
import useTranslation from 'hooks/use-translation';

export type Props = {
  articulation: Articulation;
};

export default function ArticulationCreditItemDetails(props: Props): JSX.Element {
  const { articulation } = props;

  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  return (
    <Container className='articulation-details-container'>
      <CreditItemDetailsButtonContainer creditItemID={articulation.ID} creditType={CreditType.ARTICULATION} />
      <FlexContainer gap={16} className='articulation-details-header-card-container'>
        {translation.details.articulationsTitle && (
          <Header className='articulation-details-header'>{translation.details.articulationsTitle}</Header>
        )}
        <ArticulationDetailsCard articulation={articulation} />
      </FlexContainer>
      <CreditItemDetailsFooter creditType={CreditType.ARTICULATION} articulation={articulation} />
    </Container>
  );
}
